import { Setting } from "../actionTypes/setting";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case Setting.SETTING_SUCCESS:
      return {
        ...state,
        ...action.result,
      };
    default:
      return { ...state };
  }
};
